var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.svgStyles),attrs:{"id":"base-icon"}},[(_vm.multiplatform)?_c('div',{staticClass:"svg-icon",domProps:{"innerHTML":_vm._s(
      require(("!!html-loader!@/assets/svg/" + _vm.getAppName + "/icon-" + (this.icon) + ".svg"))
    )}}):_c('div',{staticClass:"svg-icon",domProps:{"innerHTML":_vm._s(require(("!!html-loader!@/assets/svg/icon-" + (this.icon) + ".svg")))}})])}
var staticRenderFns = []

export { render, staticRenderFns }